import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import InputValidation from "../Helper/InputValidation";
import '../Styles/DayCampRegistrationPayment.scss';

const stripePromise = loadStripe("pk_live_51Qj8NvRstlwNU15E4RDarYStMSEcfHxbadUFqI9kSoC2Ux263Q9MNwMSVwFVhPLMxYWzD6R5MZDH2Eet5lG6afAY00VDLdBkCa")

function DayCampRegistrationPayment({ account, weekSelection, validateAndProcessRegistration,
   amountDue, setAmountDue, paymentAmount, setPaymentAmount, paymentType, setPaymentType,
   promoCode, setPromoCode, ProcessRegistration }) {

   const [paymentIntent, setPaymentIntent] = useState({})
   const [unprocessedPaymentIntentId, setUnprocessedPaymentIntentId] = useState()
   const [customerId, setCustomerId] = useState("")
   const [clientSecret, setClientSecret] = useState("")
   const options = { clientSecret }
   const [paymentInformationVisibility, setPaymentInformationVisibility] = useState(false)

   const [promoInputCode, setPromoInputCode] = useState('')
   const [promoMessage, setPromoMessage] = useState('')
   const [promoSearched, setPromoSearched] = useState(false)
   const [selectedPaymentOption, setSelectedPaymentOption] = useState(null)

   // What the Stripe dashboard's description is built from, e.g. "Day Camp Week 1, 2026 (Registration Fee)".
   const stripeDescriptionDetails = {
      event: {
         camp_type: weekSelection?.camp_type,
         camp_name: weekSelection?.camp_name,
         week_num: weekSelection?.week_num,
         begin_date: weekSelection?.begin_date,
      },
      paymentOption: selectedPaymentOption,
   }

   const fetchCustomer = async () => {
      let stripeCustomerId = await registerForEvent()

      if (stripeCustomerId != customerId) {
         setCustomerId(stripeCustomerId)
      }
      else if (!clientSecret) {
         let totalDue = paymentAmount * 100
         let secret = await createPaymentIntent(stripeCustomerId, totalDue)
         setClientSecret(secret.clientSecret)
      }
      else {
         updatePaymentIntent()
      }
   };

   async function registerForEvent() {
      let userEmail = account.email_address
      var response = await fetch('api/createcustomer', {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({ email: userEmail, name: `${account.first_name ?? ''} ${account.last_name ?? ''}`.trim() }),
      });
      const data = await response.json();
      return data.stripeCustomerId;
   }

   const createPaymentIntent = async (customer_id, price) => {
      var response = await fetch('api/create-payment-intent', {
         method: 'POST',
         headers: { 'Content-type': 'application/json' },
         body: JSON.stringify({ customerId: customer_id, price: price, ...stripeDescriptionDetails })
      })
      const data = await response.json();
      var clientSecretAndId = data.paymentIntentInfo;
      setUnprocessedPaymentIntentId(clientSecretAndId.id)
      return { clientSecret: clientSecretAndId.clientSecret, id: clientSecretAndId.id };
   }

   const updatePaymentIntent = async () => {
      let totalDue = (paymentAmount * 100)
      var response = await fetch('api/update-payment-intent', {
         method: 'POST',
         headers: { 'Content-type': 'application/json' },
         body: JSON.stringify({ paymentIntentId: unprocessedPaymentIntentId, price: totalDue, ...stripeDescriptionDetails })
      })
   }

   const HandlePayment = async () => {
      try {
         await validateAndProcessRegistration(paymentIntent.id);
      }
      catch {
         console.error("Stripe did not confirm payment");
      }
   };

   useEffect(() => {
      if (!paymentAmount) {
         return
      }
      setPaymentInformationVisibility(true)
      fetchCustomer();
   }, [paymentAmount])

   useEffect(() => {
      const fetchPaymentIntent = async () => {
         if (!customerId) return;
         let totalDue = (paymentAmount * 100)
         let secret = await createPaymentIntent(customerId, totalDue);
         setClientSecret(secret.clientSecret)
      }
      fetchPaymentIntent();
   }, [customerId])

   useEffect(() => {
      if (!paymentIntent?.id) {
         return
      }
      HandlePayment()
   }, [paymentIntent])

   useEffect(() => {
      if (!amountDue) {
         return
      }
      setPaymentType('Credit')
   }, [amountDue])

   async function searchPromoCode(event) {
      event.preventDefault()
      try {
         const response = await fetch('/searchpromocode', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ promoCode: promoInputCode })
         })
         const result = await response.json()
         const data = result.data

         if (data.type === 'promo_code') {
            if (data.discountType === 'FLAT') {
               setPromoCode({ isSelected: true, promoSelected: 'promo_code', promoType: 'promo_code', discountPercent: 0, discountAmount: data.discount, promoId: data.promoId })
               setPromoMessage(`Promo code applied! $${data.discount} off your registration.`)
               setPromoSearched(true)
               if (selectedPaymentOption) {
                  const base = selectedPaymentOption === 'reg_fee'
                     ? Number(weekSelection.registration_fee)
                     : Number(weekSelection.registration_fee) + Number(weekSelection.camp_fee)
                  setPaymentAmount(parseFloat(Math.max(0, base - data.discount).toFixed(2)))
               }
            } else {
               setPromoCode({ isSelected: true, promoSelected: 'promo_code', promoType: 'promo_code', discountPercent: data.discount, promoId: data.promoId })
               setPromoMessage(data.discount === 100 ? 'Promo code applied! Your camp is completely free.' : `Promo code applied! ${data.discount}% off your registration.`)
               setPromoSearched(true)
               if (selectedPaymentOption && data.discount < 100) {
                  const base = selectedPaymentOption === 'reg_fee'
                     ? Number(weekSelection.registration_fee)
                     : Number(weekSelection.registration_fee) + Number(weekSelection.camp_fee)
                  setPaymentAmount(parseFloat((base * (1 - data.discount / 100)).toFixed(2)))
               }
            }
         } else if (data.type === 'fast_track') {
            setPromoCode({ isSelected: true, promoSelected: data.promoSelected, promoType: 'fast_track', discountPercent: 100, promoId: null })
            setPromoMessage('Promo code applied! Your camp is completely free.')
            setPromoSearched(true)
         } else if (data.type === 'public_marketing') {
            setPromoCode({ isSelected: true, promoSelected: 'public_marketing', promoType: 'public_marketing', discountPercent: 0, discountAmount: data.discount, promoId: null })
            setPromoMessage(`Promo code applied! $${data.discount} off your registration.`)
            setPromoSearched(true)
            if (selectedPaymentOption) {
               const base = selectedPaymentOption === 'reg_fee'
                  ? Number(weekSelection.registration_fee)
                  : Number(weekSelection.registration_fee) + Number(weekSelection.camp_fee)
               setPaymentAmount(parseFloat(Math.max(0, base - data.discount).toFixed(2)))
            }
         } else {
            setPromoCode({ isSelected: false, promoSelected: '', promoType: null, discountPercent: 0, promoId: null })
            setPromoMessage('Invalid promo code. Please try again.')
            setPromoSearched(false)
         }
      } catch (error) {
         console.log(error)
      }
   }

   const isFreecamp = promoCode.isSelected && promoCode.discountPercent === 100
   const hasPartialDiscount = promoCode.isSelected && ((promoCode.discountPercent > 0 && promoCode.discountPercent < 100) || promoCode.discountAmount > 0)

   return (
      <div className="DayCampRegistrationPaymentContent">
         <div className="DayCampRegistrationPaymentHeading">
            Payment
         </div>
         <div className="DayCampRegistrationPaymentInformation">
            <div className="DayCampRegistrationPaymentSelectedOptions">
               <div className="DayCampRegistrationPaymentSelectedWeekRegistFee">
                  <div>
                     Registration Fee:
                  </div>
                  <div>
                     ${weekSelection.registration_fee}
                  </div>
               </div>
               <div className="DayCampRegistrationPaymentSelectedWeekCampFee">
                  <div>
                     Camp Fee:
                  </div>
                  <div>
                     ${weekSelection.camp_fee}
                  </div>
               </div>
               {hasPartialDiscount && (
                  <div className="DayCampRegistrationPaymentPromoDiscount">
                     <div>
                        Promo Discount:
                     </div>
                     <div>
                        {promoCode.discountAmount > 0 ? `-$${promoCode.discountAmount}` : `-${promoCode.discountPercent}%`}
                     </div>
                  </div>
               )}
            </div>

            {/* Promo code input — shown upfront before payment selection */}
            <div className="DayCampRegistrationPromoCodeInput">
               <div className="DayCampRegistrationPromoCodeControls">
                  <input
                     type="text"
                     placeholder="Enter promo code"
                     value={promoInputCode}
                     onChange={(e) => setPromoInputCode(e.target.value)}
                     disabled={promoSearched && promoCode.isSelected}
                  />
                  <button
                     onClick={searchPromoCode}
                     disabled={promoSearched && promoCode.isSelected}>
                     Apply
                  </button>
                  {promoSearched && promoCode.isSelected && (
                     <button onClick={() => {
                        setPromoCode({ isSelected: false, promoSelected: '', promoType: null, discountPercent: 0, discountAmount: 0, promoId: null })
                        setPromoInputCode('')
                        setPromoMessage('')
                        setPromoSearched(false)
                        setPaymentAmount(0)
                        setPaymentInformationVisibility(false)
                        setClientSecret('')
                        setSelectedPaymentOption(null)
                     }}>
                        Remove
                     </button>
                  )}
               </div>
               {promoMessage && (
                  <div className="DayCampRegistrationPromoCodeMessage" style={{ color: promoCode.isSelected ? "green" : "red" }}>
                     {promoMessage}
                  </div>
               )}
            </div>

            {/* 100% off: bypass Stripe entirely */}
            {isFreecamp ? (
               <div className="DayCampRegistrationFreecamp">
                  <p>Your promo code covers the full cost of camp. No payment is required.</p>
                  <button onClick={() => ProcessRegistration()}>
                     Complete Registration
                  </button>
               </div>
            ) : (
               <>
                  <div className="DayCampRegistrationPaymentPaymentOptionButtons">
                     <button onClick={() => {
                        setSelectedPaymentOption('reg_fee')
                        const regFee = Number(weekSelection.registration_fee)
                        const amount = hasPartialDiscount
                           ? promoCode.discountAmount > 0
                              ? parseFloat(Math.max(0, regFee - promoCode.discountAmount).toFixed(2))
                              : parseFloat((regFee * (1 - promoCode.discountPercent / 100)).toFixed(2))
                           : regFee
                        setPaymentAmount(amount)
                     }}>
                        Registration Fee Only
                     </button>
                     <button onClick={() => {
                        setSelectedPaymentOption('entire')
                        const total = Number(weekSelection.registration_fee) + Number(weekSelection.camp_fee)
                        const amount = hasPartialDiscount
                           ? promoCode.discountAmount > 0
                              ? parseFloat(Math.max(0, total - promoCode.discountAmount).toFixed(2))
                              : parseFloat((total * (1 - promoCode.discountPercent / 100)).toFixed(2))
                           : total
                        setPaymentAmount(amount)
                        setPaymentInformationVisibility(true)
                     }}>
                        Pay Entire Amount
                     </button>
                  </div>
                  {paymentInformationVisibility &&
                     <div className="DayCampRegistrationPaymentPaymentInformation">
                        <div className="DayCampRegistrationPaymentPaymentInformationAmount">
                           Payment Amount: ${Number(paymentAmount).toFixed(2)}
                        </div>
                        {clientSecret && (
                           <Elements stripe={stripePromise} options={options}>
                              <CheckoutForm
                                 setPaymentIntent={setPaymentIntent} />
                           </Elements>
                        )}
                     </div>
                  }
               </>
            )}
         </div>
      </div>
   )
}

export default DayCampRegistrationPayment
